<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Notificações</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-data-table
          :headers="headers"
          :items="notificacoes"
          hide-default-footer
          hide-default-header
          no-data-text="Nenhuma notificação no momento"
        >
          <template v-slot:item.mensagem="{ item }">
            <v-container v-if="item.tipo != 4" class="my-2 pa-0">
              <div
                v-if="item.remetente_tipo !== 'administrador'"
                class="font-weight-light caption text-capitalize"
              >
                {{ item.remetente_tipo }}
              </div>
              <div v-if="item.remetente_nome" class="font-weight-light button">
                {{ item.remetente_nome }}
              </div>
              <div class="small">{{ item.mensagem }}</div>
            </v-container>

            <v-container
              v-else-if="item.produto"
              class="flex-row py-3 pa-0"
              style="display: flex"
            >
              <v-img
                v-if="
                  Array.isArray(item.produto.fotos) && item.produto.fotos.length
                "
                :src="item.produto.fotos[0]"
                width="62px"
                height="62px"
                class="mr-4"
                style="max-width: 62px; border-radius: 4px; cursor: pointer; border: 1px solid #eee"
                @click="exibirDetalhe(item.produto)"
              />
              <v-container class="pa-0">
                <div>{{ item.produto.descricao }}</div>
                <div class="font-weight-light caption gray--text">
                  Código - {{ item.produto.id }} [{{ item.produto.codigo }}]
                </div>
                <div class="button red--text">
                  Este produto está próximo de vencer ou já está vencido!
                </div>
              </v-container>
            </v-container>
          </template>

          <template v-slot:item.acoes="{ item }">
            <td v-if="item.tipo != 4" class="layout px-0">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    dark
                    fab
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="grey"
                    class="ml-auto my-2 lighten-3"
                    @click="responderComoLida(item)"
                  >
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Marcar como lida</span>
              </v-tooltip>
            </td>
            <td v-else class="layout px-0">
              <div
                style="width: 100px; text-align: left; margin: auto 0rem auto auto"
              >
                Ainda vende este produto?
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    dark
                    fab
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="green"
                    class="ml-auto my-2 lighten-5"
                    @click="responderRenovarProdutoVencido(item)"
                  >
                    <v-icon color="green darken-2">mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Sim</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    dark
                    fab
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    class="ml-2 my-2 lighten-5"
                    @click="responderNaoRenovarProdutoVencido(item)"
                  >
                    <v-icon color="red darken-2">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Não</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <detalhe-produto :produto="produto" ref="detalheProduto" />
  </div>
</template>

<script>
import ServiceNotificacoes from "../services/notificacoes.js";
import ServiceProdutos from "@/services/produtos.js";
import DetalheProduto from "@/views/loja/DetalheProduto.vue";

export default {
  name: "Notificacoes",
  components: {
    DetalheProduto,
  },
  data() {
    return {
      loading: false,
      user: {},
      produto: {},
      headers: [
        { text: "", value: "mensagem", width: "80%", sortable: false },
        {
          text: "",
          value: "acoes",
          align: "right",
          sortable: false,
          width: "20%",
        },
      ],
      notificacoes: [],
      tipo: [
        {
          text: "Text 1",
          value: "",
        },
        {
          text: "Text 2",
          value: "",
        },
      ],
      notificacaoSelecionada: null,
    };
  },
  mounted() {
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.user = { ...this.$auth.user };
    this.listarNotificacoes();
  },
  methods: {
    async listarNotificacoes() {
      try {
        this.carregando_lojas = true;
        this.notificacoes = [];
        const { data } = await ServiceNotificacoes.index();
        this.notificacoes = data.notificacoes;

        this.$store.commit("setCountNotificacoes", data.contagem);

        const notif =
          data &&
          data.notificacoes &&
          data.notificacoes.filter((notif) => notif.produto_id);
        if (notif && notif.length > 0) {
          const { data: dataPro } = await ServiceProdutos.buscarPorId(
            notif.map((notif) => notif.produto_id)
          );

          this.notificacoes = data.notificacoes
            .filter((notif) => !notif.produto_id)
            .concat(
              data.notificacoes
                .filter((notif) => notif.produto_id)
                .map((notif) => ({
                  ...notif,
                  produto: dataPro.produtos.find(
                    (pro) => pro.id === notif.produto_id
                  ),
                }))
            );
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar as notificações");
      } finally {
        this.carregando_lojas = false;
      }
    },

    exibirDetalhe(value) {
      this.produto = value;
      this.$refs.detalheProduto.abrir();
    },

    async responderRenovarProdutoVencido(notificacao) {
      this.notificacaoSelecionada = this.clone(notificacao);
      try {
        // this.$refs.dialogoRenovarProdutoVencido.fechar();
        let response = await ServiceNotificacoes.responder(
          this.notificacaoSelecionada.id,
          1
        );
        let indice = this.notificacoes.findIndex(
          (notificacao) => notificacao.id === this.notificacaoSelecionada.id
        );
        this.notificacoes.splice(indice, 1);

        this.$store.commit(
          "setCountNotificacoes",
          this.$store.state.count_notificacoes - 1
        );
      } catch (error) {
        //
      } finally {
        //
      }
    },

    async responderNaoRenovarProdutoVencido(notificacao) {
      this.notificacaoSelecionada = this.clone(notificacao);
      try {
        // this.$refs.dialogoNaoRenovarProdutoVencido.fechar();
        let response = await ServiceNotificacoes.responder(
          this.notificacaoSelecionada.id,
          2
        );
        let indice = this.notificacoes.findIndex(
          (notificacao) => notificacao.id === this.notificacaoSelecionada.id
        );
        this.notificacoes.splice(indice, 1);

        this.$store.commit(
          "setCountNotificacoes",
          this.$store.state.count_notificacoes - 1
        );
      } catch (error) {
        //
      } finally {
        //
      }
    },

    async responderComoLida(notificacao) {
      try {
        this.notificacaoSelecionada = notificacao;
        let response = await ServiceNotificacoes.responder(
          this.notificacaoSelecionada.id,
          1
        );
        let indice = this.notificacoes.findIndex(
          (notificacao) => notificacao.id === this.notificacaoSelecionada.id
        );
        this.notificacoes.splice(indice, 1);

        this.$store.commit(
          "setCountNotificacoes",
          this.$store.state.count_notificacoes - 1
        );
      } catch (error) {
        //
      } finally {
        //
      }
    },
  },
};
</script>

<style>
.v-data-table__mobile-row {
  height: auto !important;
}
</style>
